const config:any = {
  baseUrl: "https://api.taxefy.at/api/",
  country: "AT"
};

export default config;
